import FormCliente from './FormCliente'

export default FormCliente
